
export const properties = {
  "isEuBd": true,
  "employee_this_site_label": "Employee This Site",
  "reliabilityDefinitionEmployeesActual": "ReliabilityDefinitionEmployeesActual",
  "employeesThisSiteReliabilityType": "EmployeesThisSiteReliabilityType",
  "business_name_label": "Doing Business As",
  "duns_nr_label": "D&B DUNS® number",
  "registration_nr_label": "Registration Nr",
  "regon": "Regon",
  "krs": "Krs",
  "company_description_label": "Company Description",
  "description_read_less_label": "Description Read Less",
  "ranking_label": "Ranking",
  "rankSuffix": "",
  "rankPrefix": "",
  "key_principal_label": "Key Principal",
  "seeMoreContactsAnchor": "SeeMoreContactsAnchor",
  "seeMoreContactsLabel": "See More Contacts",
  "industry_label": "Industry",
  "industries_view_more_label": "View More Industries",
  "industries_view_less_label": "View Less Industries",
  "other_industries_label": "See other industries within the",
  "other_industries_sector_label": "sector",
  "other_industries_view_more_label": "View More",
  "other_industries_view_less_label": "View Less",
  "popular_search_label": "Popular Search",
  "address_label": "Address",
  "seeOtherLocationsAnchor": "#related-companies",
  "seeOtherLocationLabel": "See Other Location",
  "subscriptionMessage": "SubscriptionMessage",
  "business_phone_label": "Business Phone",
  "business_website_label": "Business Website",
  "employee_all_sites_label": "Employee All Sites",
  "reliabilityDefinitionEmployeesModelled": "ReliabilityDefinitionEmployeesModelled",
  "reliabilityDefinitionEmployeesEstimated": "ReliabilityDefinitionEmployeesEstimated",
  "revenue_label": "Revenue",
  "reliabilityDefinitionSalesModelled": "ReliabilityDefinitionSalesModelled",
  "reliabilityDefinitionSalesEstimated": "ReliabilityDefinitionSalesEstimated",
  "reliabilityDefinitionSalesActual": "ReliabilityDefinitionSalesActual",
  "sales_growth_label": "Sales Growth",
  "growth_percentage_postfix": "%",
  "net_income_growth_label": "Net Income Growth",
  "assets_label": "Assets",
  "fiscal_year_end_label": "Fiscal Year End",
  "year_started_label": "Year Started",
  "incorporated_label": "Incorporated",
  "stock_exchange_label": "Stock Exchange",
  "staticFreeTrialLink": "StaticFreeTrialLink",
  "staticFreeTrialText": "Static Free Trial Text"
}

export const contacts = [
  {
    name: "Jong Hee Han",
    position: "President",
  },
  {
    name: "Contact 2",
    position: "?\t\t",
  },
  {
    name: "Contact 3",
    position: "?\t\t",
  },
];

export const creditReportTestData = {
  "creditReportsEntries": [
      {
          "linkText": "Erfahren Sie mehr über D&B Direct for Finance",
          "linkUrl": "https://www.dnb.com/de-de/produkte-services/db-direct-for-finance/",
          "detail": "D&B Direct for Finance",
          "paragraph": "Prüfen Sie die Kreditwürdigkeit Ihrer Geschäftspartner\n\n- Entscheiden Sie schneller und generieren Sie mehr Business\n- Automatisierte Echtzeit-Updates\n- Eindeutige Identifikation mit der D-U-N-S®-Nummer\n- Einheitliche Datenverwaltung und ERP-Integration"
      },
      {
          "linkText": "Erfahren Sie mehr über D&B Finance Analytics",
          "linkUrl": "https://www.dnb.com/de-de/produkte-services/dnb-finance-analytics/",
          "detail": "D&B Finance Analytics\n",
          "paragraph": "Die beste Credit-to-Cash-Plattform – weltweit\n\n- Prüfen Sie die Bonität von über 420 Mio. Unternehmen in über 220 Ländern\n- Globale Portfolio-Verwaltung\n- Globales Risikomonitoring"
      },
  ],
  "properties": {
      "business_credit_report_product_ca_url": "/content/dnb-ca/{{lang}}/home/products/small-business/compare-products-other-business.html",
      "seeAllLink": "\"",
      "jcr:primaryType": "nt:unstructured",
      "jcr:mixinTypes": [
          "cq:LiveRelationship"
      ],
      "description": "Sehen Sie sich detaillierte Kreditberichte über andere oder Ihr eigenes Unternehmen an ",
      "business_credit_report_product_link_text_for_ca_href_replace": "Buy Credit Reports",
      "cq:lastRolledout": {
          "year": 2023,
          "month": 6,
          "dayOfMonth": 27,
          "hourOfDay": 14,
          "minute": 52,
          "second": 20
      },
      "jcr:created": {
          "year": 2021,
          "month": 8,
          "dayOfMonth": 12,
          "hourOfDay": 0,
          "minute": 7,
          "second": 49
      },
      "headingText": "Kreditauskünfte",
      "suppress_credit_report_product_link_with_text": "Monitor, Manage, and Build Your Business Credit",
      "jcr:lastModified": {
          "year": 2023,
          "month": 6,
          "dayOfMonth": 27,
          "hourOfDay": 14,
          "minute": 52,
          "second": 20
      },
      "sling:resourceType": "dnb/dnb-mod/company/BusinessDirectoryCreditReportsFragment",
      "componentclass": "credit-reports",
      "creditReportsEntries": [
          "{\"linkText\":\"Erfahren Sie mehr über D&B Direct for Finance\",\"linkUrl\":\"https://www.dnb.com/de-de/produkte-services/db-direct-for-finance/\",\"detail\":\"D&B Direct for Finance\",\"paragraph\":\"Prüfen Sie die Kreditwürdigkeit Ihrer Geschäftspartner\\n\\n- Entscheiden Sie schneller und generieren Sie mehr Business\\n- Automatisierte Echtzeit-Updates\\n- Eindeutige Identifikation mit der D-U-N-S®-Nummer\\n- Einheitliche Datenverwaltung und ERP-Integration\"}",
          "{\"linkText\":\"Erfahren Sie mehr über D&B Finance Analytics\",\"linkUrl\":\"https://www.dnb.com/de-de/produkte-services/dnb-finance-analytics/\",\"detail\":\"D&B Finance Analytics\\n\",\"paragraph\":\"Die beste Credit-to-Cash-Plattform – weltweit\\n\\n- Prüfen Sie die Bonität von über 420 Mio. Unternehmen in über 220 Ländern\\n- Globale Portfolio-Verwaltung\\n- Globales Risikomonitoring\"}"
      ]
  },
  "businessCreditReportProductCaUrl": "/content/dnb-ca/{{lang}}/home/products/small-business/compare-products-other-business.html",
  "seeAllLinkPath": "\".html"
}

export const inTheAreasOfTestData = {
  "creditReportsEntries": [
      {
          "linkText": "Lesen Sie mehr",
          "linkUrl": "https://www.dnb.com/de-de/produkte-services/marketing-sales",
          "detail": "Marketing & Sales",
          "paragraph": "Optimieren Sie Ihre Marketing- & Vertriebsaktivitäten, verwalten Sie Kontaktpunkte mit Kunden effektiv, verbessern Sie das Kundenerlebnis und erhalten Sie wertvolle Einblicke aus Daten & Analysen."
      },
      {
          "linkText": "Lesen Sie mehr",
          "linkUrl": "https://www.dnb.com/de-de/produkte-services/risikomanagement-kreditmanagement/",
          "detail": "Risiko & Kredit",
          "paragraph": "Steuern Sie Ihr Kreditrisiko & Ihre Compliance mit den marktführenden Risiko- und Kreditmanagementlösungen. Maßgeschneidert für Ihre Bedürfnisse – ob als großes oder als kleines Unternehmen."
      },
      {
          "linkText": "Lesen Sie mehr",
          "linkUrl": "https://www.dnb.com/de-de/produkte-services/analytics-insights/",
          "detail": "Analytics & Insights Services",
          "paragraph": "Reduzieren Sie Ineffizienzen und verbessern Sie Ihre Leistung mit unseren Analyse-Dienstleistungen. Durch die Kombination von vertrauenswürdigen Daten und internem Fachwissen erhalten Sie maßgeschneiderte Lösungen."
      },
      {
          "linkText": "Lesen Sie mehr",
          "linkUrl": "https://www.dnb.com/de-de/produkte-services/firmenauskuenfte-datenqualitaet/",
          "detail": "Firmenauskünfte und Datenqualität",
          "paragraph": "Sie benötigen Daten zu Unternehmen oder Branchen? Mit unseren APIs und Webservices treffen Sie die richtigen Entscheidungen basierend auf hochwertigen und zuverlässigen Daten.\n\n"
      }
  ],
  "properties": {
      "business_credit_report_product_ca_url": "/content/dnb-ca/{{lang}}/home/products/small-business/compare-products-other-business.html",
      "seeAllLink": "\"",
      "jcr:primaryType": "nt:unstructured",
      "jcr:mixinTypes": [
          "cq:LiveRelationship"
      ],
      "business_credit_report_product_link_text_for_ca_href_replace": "Buy Credit Reports",
      "cq:lastRolledout": {
          "year": 2023,
          "month": 6,
          "dayOfMonth": 27,
          "hourOfDay": 14,
          "minute": 52,
          "second": 20
      },
      "jcr:created": {
          "year": 2021,
          "month": 8,
          "dayOfMonth": 12,
          "hourOfDay": 0,
          "minute": 7,
          "second": 49
      },
      "headingText": "Wir helfen in den Bereichen ...",
      "suppress_credit_report_product_link_with_text": "Monitor, Manage, and Build Your Business Credit",
      "jcr:lastModified": {
          "year": 2023,
          "month": 6,
          "dayOfMonth": 27,
          "hourOfDay": 14,
          "minute": 52,
          "second": 20
      },
      "sling:resourceType": "dnb/dnb-mod/company/BusinessDirectoryCreditReportsFragment",
      "creditReportsEntries": [
          "{\n  \"linkText\": \"Lesen Sie mehr\",\n  \"linkUrl\": \"https://www.dnb.com/de-de/produkte-services/marketing-sales\",\n  \"detail\": \"Marketing & Sales\",\n  \"paragraph\": \"Optimieren Sie Ihre Marketing- & Vertriebsaktivitäten, verwalten Sie Kontaktpunkte mit Kunden effektiv, verbessern Sie das Kundenerlebnis und erhalten Sie wertvolle Einblicke aus Daten & Analysen.\"\n}",
          "{\n  \"linkText\": \"Lesen Sie mehr\",\n  \"linkUrl\": \"https://www.dnb.com/de-de/produkte-services/risikomanagement-kreditmanagement/\",\n  \"detail\": \"Risiko & Kredit\",\n  \"paragraph\": \"Steuern Sie Ihr Kreditrisiko & Ihre Compliance mit den marktführenden Risiko- und Kreditmanagementlösungen. Maßgeschneidert für Ihre Bedürfnisse – ob als großes oder als kleines Unternehmen.\"\n}",
          "{\n  \"linkText\": \"Lesen Sie mehr\",\n  \"linkUrl\": \"https://www.dnb.com/de-de/produkte-services/analytics-insights/\",\n  \"detail\": \"Analytics & Insights Services\",\n  \"paragraph\": \"Reduzieren Sie Ineffizienzen und verbessern Sie Ihre Leistung mit unseren Analyse-Dienstleistungen. Durch die Kombination von vertrauenswürdigen Daten und internem Fachwissen erhalten Sie maßgeschneiderte Lösungen.\"\n}",
          "{\n  \"linkText\": \"Lesen Sie mehr\",\n  \"linkUrl\": \"https://www.dnb.com/de-de/produkte-services/firmenauskuenfte-datenqualitaet/\",\n  \"detail\": \"Firmenauskünfte und Datenqualität\",\n  \"paragraph\": \"Sie benötigen Daten zu Unternehmen oder Branchen? Mit unseren APIs und Webservices treffen Sie die richtigen Entscheidungen basierend auf hochwertigen und zuverlässigen Daten.\n\n\"\n}"
      ]
  },
  "businessCreditReportProductCaUrl": "/content/dnb-ca/{{lang}}/home/products/small-business/compare-products-other-business.html",
  "seeAllLinkPath": "\".html"
}

export const companyProfileProps = {
    "overview": {
      "industries": null,
      "otherIndustries": null,
      "viewMoreIndustries": null,
      "viewMoreOtherIndustries": null,
      "popularIndustries": null,
      "ranks": null,
      "employeesConsolidated": null,
      "employeesThisSite": null,
      "employeeConsolidatedDatablocks": {
        "value": 316000,
        "employeeFiguresDate": "2023-09-30",
        "informationScopeDescription": "Consolidated",
        "informationScopeDnBCode": 9067,
        "reliabilityDescription": "Actual",
        "reliabilityDnBCode": 9092,
        "employeeCategories": [],
        "trend": []
      },
      "employeesThisSiteDatablocks": null,
      "assets": null,
      "companyLocation": "?\t\t \t \t  \t\t  \t \t \t\t\t\t \t  \t\t\t   \t\t\t  \t\t  \t\t\t \t\t \t\t  \t\t \t\t\t\t   \t \t ",
      "companyShortSummaryTest": null,
      "descriptionReadMore": null,
      "employeesConsolidatedReliability": "Actual",
      "employeesConsolidatedReliabilityDisplay": null,
      "employeesConsolidatedValue": "?\t\t \t \t  \t\t  \t \t \t\t\t\t \t  \t\t\t   \t\t\t  \t\t  \t\t\t \t\t \t\t  \t\t \t\t\t\t   \t \t ",
      "employeesThisSiteReliability": null,
      "employeesThisSiteReliabilityDisplay": null,
      "employeesThisSiteValue": null,
      "esgContactUsHrefUrl": null,
      "esgIndustryAverage": null,
      "esgRank": null,
      "esgRankingHrefUrl": null,
      "fiscalYearEnd": "SEPT",
      "formattedRevenue": null,
      "incorporatedYear": "?\t\t \t \t  \t\t  \t \t \t\t\t\t \t  \t\t\t   \t\t\t  \t\t  \t\t\t \t\t \t\t  \t\t \t\t\t\t   \t \t ",
      "keyPrincipal": "Roland Busch",
      "keyPrincipalProfileLink": null,
      "locale": null,
      "magentoCartAddDomain": null,
      "magentoCartAddEndpoint": null,
      "magentoCartApiKey": null,
      "magentoCartDisplayName": null,
      "magentoCartServletPath": null,
      "magentoCartToken": null,
      "magentoCartUniqueId": null,
      "netIncomeGrowthPercent": null,
      "parentIndustryName": null,
      "phone": "?\t\t \t \t  \t\t  \t \t \t\t\t\t \t  \t\t\t   \t\t\t  \t\t  \t\t\t \t\t \t\t  \t\t \t\t\t\t   \t \t ",
      "primaryName": "Siemens Aktiengesellschaft",
      "revenueReliability": "Actual",
      "revenueReliabilityDisplay": null,
      "salesGrowthPercent": null,
      "stockExchange": null,
      "stockExchangeNameOnly": null,
      "tradeStyleName": null,
      "website": "new.siemens.com",
      "yearStarted": "?\t\t \t \t  \t\t  \t \t \t\t\t\t \t  \t\t\t   \t\t\t  \t\t  \t\t\t \t\t \t\t  \t\t \t\t\t\t   \t \t ",
      "encryptedDuns": "?\t\t \t \t  \t\t  \t \t \t\t\t\t \t  \t\t\t   \t\t\t  \t\t  \t\t\t \t\t \t\t  \t\t \t\t\t\t   \t \t ",
      "partnershipCompany": false,
      "privateCompany": false,
      "proprietorshipCompany": false,
      "showMoreContactsAnchor": false,
      "showNetGrowthRate": false,
      "showReadMore": false,
      "showRevenueRow": false,
      "showSalesGrowthRate": false,
      "showSeeOtherLocations": false,
      "suppressContactData": false,
      "suppressRevenue": false,
      "sales": 0,
      "registrationNumber": "80333B6684",
      "revenue": "€77.77 Mio",
      "euIndustries": "All Other Miscellaneous Electrical Equipment and Component Manufacturing, Instruments and Related Products Manufacturing for Measuring, Displaying, and Controlling Industrial Process Variables, Motor and generator manufacturing, Speed Changer, Industrial High-Speed Drive, and Gear Manufacturing, Other Measuring and Controlling Device Manufacturing",
      "euViewMoreIndustries": ", Railroad rolling stock manufacturing, Electrical equipment and supplies, nec, Process control instruments, Motors and generators, Speed changers, drives, and gears, Measuring and controlling devices, nec, Train cars and equipment, freight or passenger, Manufacture of other electrical equipment, Manufacture of instruments and appliances for measuring, testing and navigation, Manufacture of electric motors, generators and transformers, Manufacture of bearings, gears, gearing and driving elements, Manufacture of railway locomotives and rolling stock, Manufacture of communication equipment, Mfg electrical equipment/supplies, Mfg process control instruments, Mfg motors/generators, Mfg speed changers/drives, Mfg measuring/controlling devices, Mfg railroad equipment, Administrative and support, waste management and remediation services, Electromedical and Control Instruments Manufacturing, Machinery and Equipment Manufacturing, Train and Railroad Equipment Manufacturing, Manufacture of other electrical equipment n.e.c., Manufacture of industrial process control equipment, Manufacture of electric instruments and appliances for measuring, testing and navigation, Manufacture of electric instruments and appliances for measuring, checking, testing, navigating and other purposes, Manufacture of locomotives and other rail vehicles, Manufacture of rail vehicles, Manufacture of television and radio transmitters and apparatus for line telephony and line telegraphy, Manufacture of irradiation, electromedical and electrotherapeutic equipment, Manufacture of electric medical instruments and equipment, Manufacture of electric domestic appliances, Manufacture of computers and peripheral equipment, Manufacture of computers and other information processing equipment, Engineering activities for projects in specific technical fields and engineering design, Engineering activities for projects in specific technical fields, Other information technology and computer service activities, Other computer related activities n.e.c., Manufacture of non-electric instruments and appliances for measuring, testing and navigation, Manufacture of optical and precision instruments and appliances for measuring, checking, testing, navigating and other purposes, Manufacturing",
      "companyDisplayLocation": "80333 München",
      "meritScore": null,
      "meritColor": null,
      "krs": null,
      "regon": null,
      "hu": false,
      "drs": false,
      "pl": false,
      "addressUnverified": false
    },
    "contacts": {
      "showComponentInfo": true,
      "companyName": "Siemens Aktiengesellschaft",
      "contactHeading": "Nehmen Sie Kontakt auf mit <span class=\"principal-count\">28</span> Direktoren*",
      "contactDescription": "A  D&B Hoovers Subscription is your foot in the door to Siemens Aktiengesellschaft contact information.",
      "contacts": [
        {
          "id": null,
          "name": "Roland Busch",
          "position": "Chief Executive Officer",
          "profileLink": null
        },
        {
          "id": null,
          "name": "Ansprechperson 2",
          "position": "?\t\t \t \t  \t\t  \t \t \t\t\t\t \t  \t\t\t   \t\t\t  \t\t  \t\t\t \t\t \t\t  \t\t \t\t\t\t   \t \t ",
          "profileLink": null
        },
        {
          "id": null,
          "name": "Ansprechperson 3",
          "position": "?\t\t \t \t  \t\t  \t \t \t\t\t\t \t  \t\t\t   \t\t\t  \t\t  \t\t\t \t\t \t\t  \t\t \t\t\t\t   \t \t ",
          "profileLink": null
        },
        {
          "id": null,
          "name": "Ansprechperson 4",
          "position": "?\t\t \t \t  \t\t  \t \t \t\t\t\t \t  \t\t\t   \t\t\t  \t\t  \t\t\t \t\t \t\t  \t\t \t\t\t\t   \t \t ",
          "profileLink": null
        }
      ],
      "cta": {
        "altText": null,
        "cssClass": "button-primary",
        "hrefUrl": "https://www.dnb.com/de-de/aktion/dnb-hoovers-testen/",
        "label": "Alle Ansprechpersonen sehen",
        "srcUrl": null,
        "tracking": "",
        "type": "text",
        "newTab": true
      }
    },
    "financials": {
      "showComponentInfo": true,
      "name": "Siemens Aktiengesellschaft",
      "annualIncomes": null,
      "cashFlows": null,
      "assets": null,
      "liabilities": null,
      "stakeholderDetails": null,
      "haveCashFlows": false,
      "balanceSheets": null,
      "haveBalanceSheets": false,
      "showHeaderInfo": true,
      "colorBlockSize": "short",
      "componentHeading": "Finanzdaten & Risikoeinschätzung",
      "cta": {
        "altText": null,
        "cssClass": null,
        "hrefUrl": "https://www.dnb.com/de-de/firmensuche/das-datenuniversum?DUNS=0230522ba2cc1bf6d952f84cea7ff01f",
        "label": "<span class=\"icon unlock blue\"></span> Holen Sie sich einen D&B Kreditbericht über dieses Unternehmen <span class=\"icon chevron-right blue\"></span>",
        "srcUrl": null,
        "tracking": "",
        "type": "text",
        "newTab": false
      },
      "ctaone": {
        "altText": null,
        "cssClass": "''",
        "hrefUrl": "https://www.dnb.com/content/dam/bisnode/germany/products-services/dnbhoovers/DnBHoovers-sample-de-1.pdf",
        "label": "Beispielbericht öffnen <span class=\"icon chevron-right blue\"></span>",
        "srcUrl": null,
        "tracking": "",
        "type": "text",
        "newTab": true
      },
      "revenueDescription": "Finanzdaten zum 30 September 2023 (12-Monatszeitraum) in EUR",
      "revenueTitle": "Jährlicher Umsatz 2023",
      "formattedSales": "€77.77 Mio",
      "salesCurrency": "EUR",
      "financialReliability": "Tatsächliche",
      "reliability": "Actual",
      "exchangeRateInfo": null,
      "showBodyInfo": true,
      "showNavIncome": false,
      "showNavCashflow": false,
      "showNavAssets": false,
      "showNavLiabilities": false,
      "showNavEquity": false,
      "renderRevenueChart": false,
      "renderGrossProfitChart": false,
      "renderOperatingIncomeChart": false,
      "renderNetIncomeChart": false,
      "renderDilutedEPSChart": false,
      "renderCostOfRevenueChart": false,
      "renderIncomeBeforeTaxChart": false,
      "nullTicksYear": null,
      "labelIncomeYear": null,
      "labelCostOfRevenue": null,
      "labelGrossProfit": null,
      "labelOperatingIncome": null,
      "labelIncomeBeforeTax": null,
      "labelTotalNetIncome": null,
      "labelDilutedEPS": null,
      "validRevenue": false,
      "validGrossProfit": false,
      "validOperatingIncome": false,
      "validTotalNetIncome": false,
      "validDilutedEPS": false,
      "validCostOfRevenue": false,
      "validIncomeBeforeTax": false,
      "inlineMasking": false,
      "countryCode": "de",
      "reliabilityDisplay": "Tatsächliche",
      "aticksOperatingIncome": null,
      "aticksDilutedEPS": null,
      "aticksIncomeYear": null,
      "aticksGrossProfit": null,
      "aticksCostOfRevenue": null,
      "aoperatingIncome": null,
      "aticksTotalNetIncome": null,
      "aincomeBeforeTax": null,
      "aticksIncomeBeforeTax": null,
      "eu": true,
      "agrossProfit": null,
      "adilutedEPS": null,
      "acostOfRevenue": null,
      "atotalNetIncome": null,
      "aincomeYear": null
    },
    "header": {
      "companyProfileHeaderTitle": "Siemens Aktiengesellschaft",
      "companyInfoJson": "",
      "companyProfileRankingValue": 0,
      "companyProfileRankingDesc": null,
      "companyType": "?\t\t \t \t  \t\t  \t \t \t\t\t\t \t  \t\t\t   \t\t\t  \t\t  \t\t\t \t\t \t\t  \t\t \t\t\t\t   \t \t ",
      "companyRole": null,
      "companyWebsiteUrl": "new.siemens.com",
      "countryData": null,
      "companyNewHeaderParameter": {
        "companyInformationForCookie": {
          "companyAddress": "Werner-von-Siemens-Str. 1",
          "companyCity": "München",
          "companyCountry": "DE",
          "companyName": "Siemens Aktiengesellschaft",
          "companyState": "Bayern",
          "companyZip": "80333",
          "encryptedDuns": "0230522ba2cc1bf6d952f84cea7ff01f",
          "completedCreditSignalFlow": false
        },
        "companyProfileHeaderTitle": "Siemens Aktiengesellschaft"
      },
      "companyName": null,
      "dnbHooversFreeTrialBtnLink": "https://www.dnb.com/de-de/aktion/dnb-hoovers-testen/",
      "dnbHooversFreeTrialBtnText": "D&B Hoovers kostenfrei testen",
      "dunsMgrClaimCtaData": {
        "claimed": false,
        "unclaimed": false,
        "properties": {
          "claimCompanyToolTipText": "Is this your company? Claim It for free to request updates to your profile.",
          "claimedToolTipText": "Is this your company? {{dashboard_link_open}}Login{{dashboard_link_close}} to request updates to your profile",
          "updateClaimedLink": "https://my.dnb.com/login",
          "dnbHooversFreeTrialBtnLink": "https://www.dnb.com/de-de/aktion/dnb-hoovers-testen/",
          "jcr:lastModifiedBy": "lovelaceg@dnb.com",
          "cq:lastRolledout": {
            "dayOfMonth": 27,
            "hourOfDay": 14,
            "minute": 52,
            "month": 6,
            "second": 19,
            "year": 2023
          },
          "ariaLabelClaimedToolTip": "Is this your company? click claimed button or login link from tooltip",
          "claimCompanyLink": "https://www.dnb.com/duns-number/view-update-company-credit-file.html?companyDuns={{companyDuns}}",
          "sling:resourceType": "dnb/dnb-mod/company/company_new_header",
          "claimCompanyBadgeText": "Claim This Company",
          "cq:lastRolledoutBy": "seguv@dnb.com",
          "dnbHooversFreeTrialBtnText": "D&B Hoovers kostenfrei testen",
          "headingText": "D&B Firmenverzeichnis",
          "claimCompanySId": "claimthiscompany",
          "jcr:mixinTypes": [
            "cq:LiveRelationship"
          ],
          "claimedSId": "claimedbadge",
          "websiteLabel": "Webseite",
          "jcr:lastModified": {
            "dayOfMonth": 27,
            "hourOfDay": 14,
            "minute": 52,
            "month": 6,
            "second": 19,
            "year": 2023
          },
          "viewSampleLocalized": "Beispieldaten ansehen",
          "jcr:primaryType": "nt:unstructured",
          "viewSampleDataLink": "https://www.dnb.com/content/dam/bisnode/germany/products-services/dnbhoovers/DnBHoovers-sample-de-1.pdf",
          "claimedBadgeText": "Claimed",
          "ariaLabelClaimCompanyToolTip": "Is this your company? click Claim this Company or Claim It link"
        },
        "claimCompanyLinkRewritten": "https://www.dnb.com/duns-number/view-update-company-credit-file.html?companyDuns={{companyDuns}}.html",
        "enableDunsManagerClaimCompanyCta": "true",
        "organizationDunsEncrypted": "0230522ba2cc1bf6d952f84cea7ff01f",
        "organizationPrimaryName": "Siemens Aktiengesellschaft",
        "updateClaimedLinkRewritten": "https://my.dnb.com/login.html"
      },
      "eu": true
    },
    "corporate": {
      "showComponentInfo": true,
      "corporateCount": 9999,
      "corporateDescription": "Detailed profiles of all businesses owned and operated by this company for insights and prospecting.",
      "showLevel1": true,
      "currentLevel1": false,
      "nameLevel1": "?\t\t \t \t  \t\t  \t \t \t\t\t\t \t  \t\t\t   \t\t\t  \t\t  \t\t\t \t\t \t\t  \t\t \t\t\t\t   \t \t ",
      "hrefLevel1": null,
      "labelLevel1": "Ultimate Parent",
      "showLevel2": true,
      "currentLevel2": false,
      "nameLevel2": "?\t\t \t \t  \t\t  \t \t \t\t\t\t \t  \t\t\t   \t\t\t  \t\t  \t\t\t \t\t \t\t  \t\t \t\t\t\t   \t \t ",
      "hrefLevel2": "?\t\t \t \t  \t\t  \t \t \t\t\t\t \t  \t\t\t   \t\t\t  \t\t  \t\t\t \t\t \t\t  \t\t \t\t\t\t   \t \t ",
      "labelLevel2": "View All with Free Trial",
      "showLevel3": true,
      "currentLevel3": false,
      "nameLevel3": "?\t\t \t \t  \t\t  \t \t \t\t\t\t \t  \t\t\t   \t\t\t  \t\t  \t\t\t \t\t \t\t  \t\t \t\t\t\t   \t \t ",
      "hrefLevel3": "?\t\t \t \t  \t\t  \t \t \t\t\t\t \t  \t\t\t   \t\t\t  \t\t  \t\t\t \t\t \t\t  \t\t \t\t\t\t   \t \t ",
      "labelLevel3": "View All with Free Trial",
      "inlineMasking": true
    }
  }
